import apiClient from './client.js';

const noCacheConfig = () => ({
  headers: { 'Cache-Control': 'no-cache' },
  params: { ts: Date.now() }
});

export async function getAdminUsers () {
  const { data } = await apiClient.get('/admin/users', noCacheConfig());
  return data?.items || [];
}

export async function createUser (payload) {
  const { data } = await apiClient.post('/admin/users', payload);
  return data?.user;
}

export async function updateUser (id, payload) {
  const { data } = await apiClient.patch(`/admin/users/${id}`, payload);
  return data?.user;
}

export async function getAdminTeams () {
  const { data } = await apiClient.get('/admin/teams', noCacheConfig());
  return data?.items || [];
}

export async function createTeam (teamData) {
  const { data } = await apiClient.post('/admin/teams', teamData);
  return data?.team;
}

export async function updateTeam (id, teamData) {
  const { data } = await apiClient.patch(`/admin/teams/${id}`, teamData);
  return data?.team;
}

export async function deleteTeam (id) {
  await apiClient.delete(`/admin/teams/${id}`);
}

export async function getPlatformCoefficients () {
  const { data } = await apiClient.get('/admin/platform-coefficients');
  return data?.items || [];
}

export async function updatePlatformCoefficient (platform, payload) {
  const { data } = await apiClient.put(`/admin/platform-coefficients/${platform}`, payload);
  return data?.item;
}

export async function impersonateUser (userId) {
  const { data } = await apiClient.post(`/admin/impersonate/${userId}`);
  return { ok: data?.ok, user: data?.user };
}

export async function backfillHellosignSignedAt () {

  const { data } = await apiClient.post('/admin/dropbox-sign/backfill-signed-at');
  return data;
}

export async function getSheetBindings () {
  const { data } = await apiClient.get('/admin/sheet-bindings', noCacheConfig());
  return data?.items || [];
}

export async function createSheetBinding (payload) {
  const { data } = await apiClient.post('/admin/sheet-bindings', payload);
  return data?.item;
}

export async function updateSheetBinding (id, payload) {
  const { data } = await apiClient.patch(`/admin/sheet-bindings/${id}`, payload);
  return data?.item;
}

export async function deleteSheetBinding (id) {
  const { data } = await apiClient.delete(`/admin/sheet-bindings/${id}`);
  return data;
}

export async function syncSheetBinding (id) {

  const { data } = await apiClient.post(`/admin/sheet-bindings/${id}/sync`, undefined, { timeout: 300000 });
  return data?.stats;
}
